var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMachineMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.96,
    height: 55.491,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowMachineMulti_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 469",
    fill: "none",
    d: "M0 0h43.96v55.491H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 824",
    clipPath: "url(#arrowMachineMulti_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 316",
    fill: "#040000",
    clipPath: "url(#arrowMachineMulti_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 336",
    d: "M21.315.248L.376 17.677a1.038 1.038 0 00.665 1.838h41.877a1.038 1.038 0 00.665-1.838L22.644.248a1.037 1.037 0 00-1.33 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 337",
    d: "M12.821 54.731a.69.69 0 00.579.76h17.157a.69.69 0 00.581-.76v-3.794H12.821z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 400",
    d: "M12.822 18.783h18.317v20.305H12.822z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 401",
    d: "M12.822 41.998h18.317v6.027H12.822z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMachineMulti);
export default __webpack_public_path__ + "static/media/arrowMachineMulti.2a8c4609995c9468.svg";
export { ForwardRef as ReactComponent };